export const formatPrice = (price: any, currency: string = '$'): string => {
  const numPrice = Number(price);
  if (isNaN(numPrice)) return `${currency}0.00`;

  return numPrice.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).replace('$', currency); // Replace $ with custom symbol if needed
};


export const formatCoord = (coord: number) => {
  const rounded = parseFloat(coord.toFixed(6));
  return rounded;
};

// Format full English date
export const formatFullDate = (dateString: string) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
};